export default "__VITE_ASSET__BOp9skfP__"